import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AuthGuard } from '@/components/AuthGuard';
import { LoginPage } from '@/features/auth/LoginPage';
import { AuthCallback } from '@/features/auth/AuthCallback';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { UploadPage } from '@/features/render/UploadPage';
import { RenderDetailPage } from '@/features/render/RenderDetailPage';
import { RenderListPage } from '@/features/render/RenderListPage';
import { ProfilePage } from '@/features/profile/ProfilePage';
import { CreditsPage } from '@/features/credits/CreditsPage';
import { LandingPage } from '@/features/landing/LandingPage';
import { LtdPage } from '@/features/ltd/LtdPage';
import { SeoPage } from '@/features/seo/SeoPage';
import { TermsPage } from '@/features/legal/TermsPage';
import { PrivacyPage } from '@/features/legal/PrivacyPage';
import { LicensePage } from '@/features/legal/LicensePage';
import { SupportPage } from '@/features/legal/SupportPage';

export const router = createBrowserRouter([
  { path: '/', element: <LandingPage /> },
  { path: '/ltd', element: <LtdPage /> },
  { path: '/lifetime', element: <LtdPage /> },
  { path: '/comparar/*', element: <SeoPage /> },
  { path: '/solucoes/*', element: <SeoPage /> },
  { path: '/uso/*', element: <SeoPage /> },
  { path: '/termos', element: <TermsPage /> },
  { path: '/privacidade', element: <PrivacyPage /> },
  { path: '/licenca-de-imagem', element: <LicensePage /> },
  { path: '/suporte', element: <SupportPage /> },
  { path: '/auth/login', element: <LoginPage /> },
  { path: '/auth/callback', element: <AuthCallback /> },
  {
    element: <AuthGuard />,
    children: [
      { path: '/dashboard', element: <DashboardPage /> },
      { path: '/upload', element: <UploadPage /> },
      { path: '/renders', element: <RenderListPage /> },
      { path: '/renders/:id', element: <RenderDetailPage /> },
      { path: '/profile', element: <ProfilePage /> },
      { path: '/creditos', element: <CreditsPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
